import { render, staticRenderFns } from "./LockClosedIcon.vue?vue&type=template&id=daccdc92&scoped=true&"
import script from "./LockClosedIcon.vue?vue&type=script&lang=js&"
export * from "./LockClosedIcon.vue?vue&type=script&lang=js&"
import style0 from "./LockClosedIcon.vue?vue&type=style&index=0&id=daccdc92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daccdc92",
  null
  
)

export default component.exports